import { useMemo } from 'react';
import { Item } from '@opengov/bnp-component-folders/src';
import { EReportsListV4ItemType, IFolder, IReportV4 } from '@opengov/reporting-types';

export function useSelectedFoldersAndReports(selectedItems: (IFolder | IReportV4)[]) {
  const items = useMemo(() => {
    return selectedItems.map(({ id, title }) => ({ id, title }) as Item);
  }, [selectedItems]);

  const { selectedFolders, selectedReports, selectedFolderIds, selectedReportIds } = useMemo(() => {
    return selectedItems.reduce<{
      selectedFolders: IFolder[];
      selectedReports: IReportV4[];
      selectedFolderIds: string[];
      selectedReportIds: string[];
    }>(
      (acc, item) => {
        const isFolder = item.type === EReportsListV4ItemType.FOLDER;
        const isReport =
          item.type === EReportsListV4ItemType.ACCOUNT_SUMMARY_REPORT ||
          item.type === EReportsListV4ItemType.CHART_AND_DETAILS_REPORT;

        if (isFolder) {
          acc.selectedFolders.push(item);
          acc.selectedFolderIds.push(`${item.id}`);
        } else if (isReport) {
          acc.selectedReports.push(item);
          acc.selectedReportIds.push(item.id);
        }

        return acc;
      },
      {
        selectedFolders: [],
        selectedReports: [],
        selectedFolderIds: [],
        selectedReportIds: []
      }
    );
  }, [selectedItems]);

  return {
    items,
    selectedFolders,
    selectedFolderIds,
    selectedReports,
    selectedReportIds
  };
}
